import React, { useState } from 'react';
import './ButtonSidebar.css';
import starSVG from '../Iconos/star-2.svg';
import share2SVG from '../Iconos/share2.svg';
import circleSVG from '../Iconos/clock-2.svg';
import xsvg from '../Iconos/x-circle.svg';
import { useTranslation } from 'react-i18next';
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';

const ButtonSidebar2: React.FC<{ onEdit: () => void, onSaveDraft: () => void, onOptimize: () => void }> = ({ onEdit, onSaveDraft, onOptimize }) => {
  const [hoveredButton, setHoveredButton] = useState<string | null>(null);
  const [showShareOptions, setShowShareOptions] = useState(false);
  const { t } = useTranslation();

  const handleMouseEnter = (buttonName: string) => {
    setHoveredButton(buttonName);
  };

  const handleMouseLeave = () => {
    setHoveredButton(null);
  };

  const handleShareClick = () => {
    setShowShareOptions(!showShareOptions);
  };

  const handleCloseShareOptions = () => {
    setShowShareOptions(false);
  };

  const shareUrl = window.location.href;
  const shareTitle = "Check out this content!";

  return (
    <div className='sidebar'>
      <div className='sidebar-questions'></div>
      <div className="sidebar-buttons">

        <button className="sidebar-button"
          onClick={onOptimize}
          onMouseEnter={() => handleMouseEnter('star')}
          onMouseLeave={handleMouseLeave}>
          <img src={starSVG} alt="Add" />
          {hoveredButton === 'star' && <span className="button-label">{t('Mejorar')}</span>}
        </button>
        <button className="sidebar-button"
          onClick={onSaveDraft}
          onMouseEnter={() => handleMouseEnter('reloj')}
          onMouseLeave={handleMouseLeave}>
          <img src={circleSVG} alt="Settings" />
          {hoveredButton === 'reloj' && <span className="button-label">{t('Borrador')}</span>}
        </button>
        <button className="sidebar-button"
          onClick={handleShareClick}
          onMouseEnter={() => handleMouseEnter('share')}
          onMouseLeave={handleMouseLeave}>
          <img src={share2SVG} alt="Settings" />
          {hoveredButton === 'share' && <span className="button-label">{t('Compartir')}</span>}
        </button>
        {showShareOptions && (
          <div className="share-options">
            <button className="sidebar-button" onClick={handleCloseShareOptions}>
              <img src={xsvg} alt="Cerrar" />
            </button>
            <FacebookShareButton url={shareUrl} title={shareTitle}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>
            <TwitterShareButton url={shareUrl} title={shareTitle}>
              <TwitterIcon size={32} round />
            </TwitterShareButton>
            <WhatsappShareButton url={shareUrl} title={shareTitle}>
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
            <EmailShareButton url={shareUrl} subject={shareTitle} body="Check out this link: ">
              <EmailIcon size={32} round />
            </EmailShareButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default ButtonSidebar2;
